import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Location } from 'features/locations/location.types';

type LocationOperatorProps = {
  location: Location | undefined;
};

export const LocationOperator = (
  props: LocationOperatorProps,
): JSX.Element | null => {
  const { location } = props;
  const { t } = useTranslation();

  if (!location?.data.organization?.logoUrl) return null;

  const { websiteUrl } = location.data.organization;
  return (
    <>
      <Grid size={12} sx={{ borderBottom: 1, borderColor: 'divider', p: 2 }}>
        <Typography variant="h3">{t('location.sections.operator')}</Typography>
      </Grid>

      <Grid size={12} sx={{ justifySelf: 'center' }}>
        <Box
          alt={location.data.organization.displayName}
          component="img"
          onClick={
            websiteUrl
              ? () => window.open(websiteUrl, '_blank', 'noopener,noreferrer')
              : undefined
          }
          src={location.data.organization.logoUrl}
          sx={{
            cursor: websiteUrl ? 'pointer' : 'default',
            maxHeight: '200px',
            maxWidth: '200px',
            mt: 2,
          }}
        />
      </Grid>
    </>
  );
};
